// SB Admin 2 styled WorksheetPrintGuidePage
import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Nav, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPrint,
  faQrcode,
  faExclamationTriangle,
  faStore,
  faCheckCircle,
  faMobileAlt
} from '@fortawesome/free-solid-svg-icons';
import '../admin-v2/styles/sb-admin-2.scss';

function WorksheetPrintGuidePage() {
  const [activeTab, setActiveTab] = useState("familymart");

  const stores = [
    {
      id: "familymart",
      name: "ファミリーマート",
      color: "success",
      icon: faStore,
      instruction: "マルチコピー機の前面パネルから「2次元コードを持っている」をタップして、QRコードを読ませます",
      image: "/images/qrcode_printer_fm.png",
      steps: [
        "マルチコピー機の画面をタップ",
        "「2次元コードを持っている」を選択",
        "ページ下にあるQRコードをQRコードリーダーにかざす",
        "ファイルを選択して印刷"
      ]
    },
    {
      id: "lawson",
      name: "ローソン",
      color: "primary",
      icon: faStore,
      instruction: "マルチコピー機の前面パネルから「QRコードを読み取る」をタップして、QRコードを読ませます",
      image: "/images/qrcode_printer_lw.png",
      steps: [
        "マルチコピー機の画面をタップ",
        "「QRコードを読み取る」を選択",
        "ページ下にあるQRコードをQRコードリーダーにかざす",
        "ファイルを選択して印刷"
      ]
    }
  ];

  return (
    <div style={{ backgroundColor: '#f8f9fc', minHeight: '100vh' }}>
      <Container fluid className="py-5">
        {/* Hero Section */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow border-0">
              <Card.Body 
                className="p-5 text-center text-white"
                style={{
                  background: 'linear-gradient(135deg, #4e73df 0%, #224abe 50%, #1cc88a 100%)',
                  borderRadius: '0.35rem',
                  boxShadow: '0 0.15rem 1.75rem 0 rgba(78, 115, 223, 0.15)'
                }}
              >
                <FontAwesomeIcon icon={faPrint} className="fa-4x mb-4" style={{color: 'white'}} />
                <h1 className="display-4 mb-3" style={{color: 'white'}}>プリント印刷ガイド</h1>
                <p className="lead mb-4" style={{color: 'white'}}>コンビニのマルチコピー機で簡単印刷！</p>
                <div className="d-flex justify-content-center flex-wrap gap-3">
                  <span className="badge bg-white text-primary fs-6 px-3 py-2">
                    <FontAwesomeIcon icon={faStore} className="me-2" />
                    ファミリーマート対応
                  </span>
                  <span className="badge bg-white text-primary fs-6 px-3 py-2">
                    <FontAwesomeIcon icon={faStore} className="me-2" />
                    ローソン対応
                  </span>
                  <span className="badge bg-white text-primary fs-6 px-3 py-2">
                    <FontAwesomeIcon icon={faQrcode} className="me-2" />
                    QRコード印刷
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 注意事項 */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow border-left-warning">
              <Card.Body className="p-4">
                <h5 className="text-warning mb-3">
                  <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                  注意事項
                </h5>
                <ul className="mb-0">
                  <li className="mb-2">1枚20円の印刷料金がかかります（白黒印刷）</li>
                  <li>コンビニの混雑時は待ち時間が発生する事もございます、余裕をもって印刷して下さい</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 店舗別操作方法 */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow">
              <Card.Header className="bg-primary text-white py-3">
                <h4 className="mb-0 text-center">
                  <FontAwesomeIcon icon={faStore} className="me-2" />
                  マルチコピー機の操作方法
                </h4>
              </Card.Header>
              <Card.Body className="p-0">
                <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                  <Nav variant="tabs" className="justify-content-center p-3 bg-light">
                    {stores.map((store) => (
                      <Nav.Item key={store.id}>
                        <Nav.Link 
                          eventKey={store.id}
                          className={`px-4 py-3 fw-bold text-${store.color}`}
                        >
                          <FontAwesomeIcon icon={store.icon} className="me-2" />
                          {store.name}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                  
                  <Tab.Content className="p-4">
                    {stores.map((store) => (
                      <Tab.Pane key={store.id} eventKey={store.id}>
                        <Row className="align-items-start">
                          <Col lg={6} className="mb-4">
                            <h5 className={`text-${store.color} mb-3`}>
                              <FontAwesomeIcon icon={store.icon} className="me-2" />
                              {store.name} での操作方法
                            </h5>
                            
                            <div className={`alert alert-${store.color} bg-light border-${store.color}`}>
                              <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                              {store.instruction}
                            </div>

                            <h6 className="fw-bold mt-4 mb-3">詳細手順:</h6>
                            <ol className="list-unstyled">
                              {store.steps.map((step, stepIndex) => (
                                <li key={stepIndex} className="mb-3 d-flex align-items-start">
                                  <span 
                                    className={`badge bg-${store.color} rounded-circle me-3 d-flex align-items-center justify-content-center`}
                                    style={{ width: '30px', height: '30px', fontSize: '14px' }}
                                  >
                                    {stepIndex + 1}
                                  </span>
                                  <span className="pt-1">{step}</span>
                                </li>
                              ))}
                            </ol>
                          </Col>

                          <Col lg={6}>
                            <Card className={`border-${store.color} border-2`}>
                              <Card.Header className="bg-dark text-white text-center">
                                <h6 className="mb-0">マルチコピー機の操作画面</h6>
                              </Card.Header>
                              <Card.Body className="p-2">
                                <img 
                                  src={store.image}
                                  alt={`${store.name}のマルチコピー機操作画面`}
                                  className="img-fluid"
                                  style={{
                                    width: '100%',
                                    height: '300px',
                                    objectFit: 'contain',
                                    backgroundColor: '#f5f5f5'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <div 
                                  className="d-none align-items-center justify-content-center flex-column bg-light"
                                  style={{ height: '300px' }}
                                >
                                  <FontAwesomeIcon icon={faStore} className="fa-4x text-muted mb-3" />
                                  <p className="text-muted">操作画面の画像を準備中...</p>
                                  <small className="text-muted">{store.name}のマルチコピー機</small>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* QRコードセクション - スマートフォン対応 */}
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <Card className="shadow border-0">
              <Card.Body className="p-5 text-center">
                <FontAwesomeIcon icon={faMobileAlt} className="fa-4x text-primary mb-4" />
                <h3 className="text-gray-800 mb-4">QRコード</h3>
                <p className="text-gray-600 mb-4">
                  このQRコードをコンビニのマルチコピー機で読み取ってください
                </p>
                
                {/* QRコード表示 - レスポンシブ対応 */}
                <div className="d-flex justify-content-center w-100">
                  <img 
                    src="/images/print_qr.jpg" 
                    alt="印刷用QRコード"
                    style={{ 
                      width: '300px',
                      height: '300px',
                      maxWidth: '80vw',
                      maxHeight: '80vw',
                      objectFit: 'contain',
                      display: 'block'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div 
                    className="d-none align-items-center justify-content-center flex-column bg-light border-3 border-dashed"
                    style={{ 
                      width: '300px',
                      height: '300px',
                      maxWidth: '80vw',
                      maxHeight: '80vw'
                    }}
                  >
                    <FontAwesomeIcon icon={faQrcode} className="fa-4x text-muted mb-3" />
                    <h6 className="text-muted">QRコード準備中</h6>
                  </div>
                </div>

                {/* QRコード使用方法 */}
                <div className="alert alert-info mt-4">
                  <FontAwesomeIcon icon={faQrcode} className="me-2" />
                  <strong>QRコードの使い方:</strong> 
                  マルチコピー機のQRコードリーダーにスマートフォンの画面をかざしてください
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default WorksheetPrintGuidePage;